import React, { useCallback } from 'react';
import ComponentPropTypes from './ComponentPropTypes';
import { ToggleGroup, ToggleGroupItem } from '@patternfly/react-core';
import _ from 'lodash';

const isSelected = (currentValues, option) => {
  if (_.isArray(currentValues)) {
    return _.some(currentValues, value => _.isEqual(value, option.value));
  }
  return _.isEqual(currentValues, option.value);
};

const ToggleGroupComponent = ({ model, value, onChange }) => {

  const _onChange = useCallback((selected, buttonIndex) => {
    const changedOption = model.options[buttonIndex];

    if (_.isArray(value) || model.properties?.isMultiple) {
      const _value = value ?? []; // If initial value is null/undefined
      if (selected) {
        onChange(model, [..._value, changedOption.value]);
      } else {
        onChange(model, _.reject(_value, currentValue => _.isEqual(currentValue, changedOption.value)));
      }
    } else if (selected) {
      onChange(model, changedOption.value);
    } // TODO: allow deselection of single values?

  }, [model, onChange, value]);

  if (_.isEmpty(model.options)) {
    return <></>;
  }

  return (
    <ToggleGroup
      aria-label="Default with multiple selectable"
      value={value ?? ''}
      onChange={_onChange}
      isCompact={model.properties?.isCompact}
      areAllGroupsDisabled={model.disabled}
    >{ _.map(model.options, (option, key) => {
        return (<ToggleGroupItem
          key={key}
          aria-label={option.text ?? '' + key}
          aria-valuetext={'' + key}
          text={option.text}
          buttonId={key}
          isSelected={isSelected(value, option)}
          onChange={(_event, selected) => _onChange(selected, key)}
          isDisabled={option.isDisabled}
        />);
      })
      }</ToggleGroup>
  );
};

ToggleGroupComponent.propTypes = ComponentPropTypes;

export default React.memo(ToggleGroupComponent);
